// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__Ie8oR","modalForm":"UpgradeEpcsModal_modalForm__190Vg","modalFooter":"UpgradeEpcsModal_modalFooter__25tnS"};